import Decimal from 'decimal.js'
import { toast } from 'react-toastify'

import {
  GetDistanceCalculationQuery,
  GoogleDistanceStatus,
  useGetDistanceCalculationLazyQuery,
} from 'generated/graphql'

const useMapDistanceCalculation = (
  bookingAddresses: any,
  setValue: any,
  isWaitAndReturn: boolean,
) => {
  const handleDistanceCalculation = (
    data: GetDistanceCalculationQuery,
    distanceType: 'distance' | 'returnDistance',
  ) => {
    const { status, distance: rawDistance, errorMessage } = data.distanceCalculation

    if (status === GoogleDistanceStatus.Success) {
      const distance = new Decimal(rawDistance).toDP(2, Decimal.ROUND_FLOOR).toNumber()

      setValue(distanceType, distance)
    } else if (status === GoogleDistanceStatus.Error) {
      toast.warning(errorMessage)
    }
  }

  const [
    getDistanceCalculation,
    { data: distanceCalculationData, loading: distanceCalculationLoading },
  ] = useGetDistanceCalculationLazyQuery({
    // onCompleted: (data) => {
    //   handleDistanceCalculation(data)
    // },
    onError: (error) => {
      toast.error(error.message)
    },
  })

  const calculateDistance = (addresses: Array<{ id: string }>) => {
    const googleAddressInput = addresses.map((address, index) => {
      const bookingAddressNew = bookingAddresses?.find((ba) => ba.id === address.id)

      return {
        sequenceOrder: index,
        addressLine1: bookingAddressNew?.address.addressLine1,
        ...(bookingAddressNew?.address.addressLine2 && {
          addressLine2: bookingAddressNew?.address.addressLine2,
        }),
        postcode: bookingAddressNew?.address.postcode,
        city: bookingAddressNew?.address.city,
        countryId: bookingAddressNew?.address.countryId,
      }
    })

    getDistanceCalculation({ variables: { input: googleAddressInput } }).then(
      ({ data }) => data && handleDistanceCalculation(data, 'distance'),
    )

    if (isWaitAndReturn) {
      const lastTwoAddresses = googleAddressInput.slice(-2)

      getDistanceCalculation({ variables: { input: lastTwoAddresses } }).then(
        ({ data }) => data && handleDistanceCalculation(data, 'returnDistance'),
      )
    } else {
      setValue('returnDistance', 0, { shouldDirty: true })
    }
  }

  return {
    calculateDistance,
    distanceCalculationData,
    distanceCalculationLoading,
  }
}

export default useMapDistanceCalculation
